<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiEye } from "@mdi/js";
export default {
  name: "MdiEye",
  data() {
    return {
      svgPath: mdiEye,
    };
  },
};
</script>
